import React from 'react'
import  "./process2.css"
function Process2() {
  return (
    <div>

<h1 className='titre-process'> Comment ça se passe?</h1>
<h4 className='horaire'>Tous les mercredis de 14H a 16H à l'école Jean Jaures Ravine Blanche et les samedis de 13h à 15h au Stade Michel Volnay. </h4>
<div class="grades">
  <div class="indGrade">
   
    <p>Assistez au premier cours avec votre enfant</p>
    
  </div>
  <div class="indGrade">
  
      
    <p>Un document d'inscription vous sera transmis</p>
  </div>
  <div class="indGrade">
    
      
    <p>La cotisation est de 20€ pour l'année</p>
    
  </div>
  
</div>

    </div>
  )
}

export default Process2